"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidToken = exports.isJTWToken = void 0;
const isJTWToken = token => /(^[\w-]*\.[\w-]*\.[\w-]*$)/.test(token);
exports.isJTWToken = isJTWToken;
const hasValidToken = token => {
  if (!token || !(0, exports.isJTWToken)(token)) {
    return false;
  }
  const decodedToken = JSON.parse(atob(token.split('.')[1]));
  const expiryTimestamp = decodedToken.exp;
  const currentTimestamp = new Date().getTime() / 1000;
  return !(!expiryTimestamp || expiryTimestamp && expiryTimestamp <= currentTimestamp);
};
exports.hasValidToken = hasValidToken;
//# sourceMappingURL=index.js.map